/* Dansk katalog for locale-manual-preview-no.js.
 * N\u00f8kler som mangler her, vises p\u00e5 engelsk. */
window.PlummeI18n.register('da', {
  'manualPreview.reset': 'Nulstil',
  'manualPreview.title': 'Bogf\u00f8ring',
  'manualPreview.details': 'Detaljer',
  'manualPreview.summary': 'Opsummering pr. konto',
  'manualPreview.date': 'Dato',
  'manualPreview.account': 'Konto',
  'manualPreview.vat': 'Momskode',
  'manualPreview.before': 'Saldo f\u00f8r',
  'manualPreview.amount': 'Bel\u00f8b',
  'manualPreview.after': 'Saldo efter',
  'manualPreview.debit': 'Debet',
  'manualPreview.credit': 'Kredit',
  'manualPreview.net': 'Netto\u00e6ndring',
  'manualPreview.warning.balances': 'Saldi er ikke tilg\u00e6ngelige fra regnskabsgrundlaget. Posteringerne vises uden saldo f\u00f8r og efter.',
  'manualPreview.warning.editing': 'Ved korrektion vises erstatningsposteringen her. Saldo f\u00f8r og efter vises ikke, fordi korrektionen ogs\u00e5 kan tilbagef\u00f8re et tidligere bilag.',
  'manualPreview.warning.years': 'Posteringerne g\u00e5r over flere kalender\u00e5r. Bogf\u00f8ringslinjerne vises, men saldo f\u00f8r og efter er ikke beregnet p\u00e5 tv\u00e6rs af \u00e5r.',
  'manualPreview.warning.country': 'Forh\u00e5ndsvisningen mangler regnskabsland eller underst\u00f8tter ikke den valgte momsbehandling for landet.',
});
